export var hasModule = function hasModule(productId, modulesV2) {
  return modulesV2 && modulesV2[productId];
};